import { LayoutDashboard, Shield, Terminal, DoorOpen, Music, Blocks, BarChart3, CreditCard, Rss, Clock, Vote, Sparkles, Ticket, UsersRound, Wand2, ShieldCheck, Smile, Tags, ShieldAlert, ClipboardList, Languages, Coins, Copy, Cake, IdCard, MessageSquareShare, ScrollText, Pin, Megaphone, MessageCircleQuestion, UserPlus } from "lucide-react";

export const NAV_GROUPS = [
  { id: "general", label: "General", items: [
    { to: "", icon: LayoutDashboard, label: "Overview", end: true },
    { to: "analytics", icon: BarChart3, label: "Analytics" },
    { to: "logging", icon: ScrollText, label: "Logs" },
  ] },
  { id: "moderation", label: "Moderation", items: [
    { to: "moderation", icon: Shield, label: "Moderation" },
    { to: "automod", icon: ShieldAlert, label: "Auto-Mod" },
    { to: "staff", icon: UsersRound, label: "Staff" },
    { to: "botmasters", icon: ShieldCheck, label: "Bot Masters" },
  ] },
  { id: "community", label: "Community", items: [
    { to: "welcome", icon: DoorOpen, label: "Welcome" },
    { to: "autoroles", icon: UserPlus, label: "Auto-Roles" },
    { to: "reaction-roles", icon: Tags, label: "Reaction Roles" },
    { to: "profile-cards", icon: IdCard, label: "Profile Cards" },
    { to: "birthdays", icon: Cake, label: "Birthdays" },
    { to: "invites", icon: MessageSquareShare, label: "Invites", premium: true },
    { to: "polls", icon: Vote, label: "Polls" },
    { to: "sticky", icon: Pin, label: "Sticky Messages" },
  ] },
  { id: "engagement", label: "Engagement", items: [
    { to: "engagement", icon: Coins, label: "Economy" },
    { to: "music", icon: Music, label: "Music" },
    { to: "translation", icon: Languages, label: "Translation", premium: true },
  ] },
  { id: "support", label: "Support", items: [
    { to: "tickets", icon: Ticket, label: "Tickets" },
    { to: "applications", icon: ClipboardList, label: "Applications" },
    { to: "ai-help", icon: MessageCircleQuestion, label: "AI Help" },
  ] },
  { id: "alerts", label: "Alerts & Posts", items: [
    { to: "announcements", icon: Megaphone, label: "Announcements" },
    { to: "social", icon: Rss, label: "Social" },
    { to: "timers", icon: Clock, label: "Timers" },
  ] },
  { id: "customise", label: "Customise", items: [
    { to: "commands", icon: Terminal, label: "Commands" },
    { to: "plugins", icon: Blocks, label: "Plugins" },
    { to: "ai", icon: Sparkles, label: "AI Studio", premium: true },
    { to: "personalizer", icon: Wand2, label: "Bot Personalizer" },
    { to: "templates", icon: Copy, label: "Templates" },
    { to: "emojis", icon: Smile, label: "Emojis" },
  ] },
  { id: "account", label: "Account", items: [
    { to: "billing", icon: CreditCard, label: "Billing" },
  ] },
];

export const navTestId = (label) => `nav-${label.toLowerCase().replace(/[^a-z]/g, "")}`;

export function findNavItem(subpath) {
  const first = (subpath || "").split("/")[0];
  for (const g of NAV_GROUPS) for (const i of g.items) if (i.to === first) return { group: g, item: i };
  return null;
}

const PERMS = [0, 1, 2, 4, 5, 6, 7, 10, 11, 13, 14, 15, 16, 18, 20, 21, 27, 28, 29, 30, 34, 35, 38, 40];
export const BOT_PERMISSIONS = PERMS.reduce((a, b) => a | (BigInt(1) << BigInt(b)), BigInt(0)).toString();

export const inviteUrl = (clientId, discordGuildId) =>
  `https://discord.com/oauth2/authorize?client_id=${encodeURIComponent(clientId)}&scope=bot%20applications.commands&permissions=${BOT_PERMISSIONS}` +
  (discordGuildId ? `&guild_id=${encodeURIComponent(discordGuildId)}&disable_guild_select=true` : "");
